import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

export default function Copyright(): JSX.Element {
    return (
        <>
            <Typography variant="body2" color="textSecondary" align="center">
                © {new Date().getFullYear()} <Link color="inherit" href="https://trimustikasejagat.com/">PT. Tri Mustika Sejagat</Link>. All rights reserved.
            </Typography>
        </>
    );
}
